import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import StorageLimit from 'mbs-ui-shared@models/StorageLimit';

interface StorageLimitsState {
  entities: Record<number, StorageLimit>;
  ids: number[];
  loading: boolean;
  loaded: boolean;
}

const initialState: StorageLimitsState = {
  entities: {},
  ids: [],
  loading: false,
  loaded: false
};

export const StorageLimitsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('StorageLimitsStore'),
  withState<StorageLimitsState>(initialState),
  withComputed((store) => ({
    all: computed(() =>
      store
        .ids()
        .map((id) => store.entities()[id])
        .filter(Boolean)
    )
  })),
  withMethods((store) => ({
    setLoading(loading: boolean): void {
      patchState(store, { loading });
    },
    setAll(limits: StorageLimit[]): void {
      const entities: Record<number, StorageLimit> = {};
      const ids: number[] = [];

      for (const limit of limits) {
        entities[limit.id] = limit;
        ids.push(limit.id);
      }

      patchState(store, { entities, ids, loaded: true });
    },
    invalidate(): void {
      patchState(store, initialState);
    }
  }))
);
